import { type ComponentOverrides } from "theme/theme.types";

/** `rounded` would otherwise take the theme's 8px `shape.borderRadius`; Figma's skeleton bars are 4px. */
export const SKELETON_ROUNDED_RADIUS = 4;

export const MuiSkeleton: ComponentOverrides["MuiSkeleton"] = {
  styleOverrides: {
    root: ({ theme }) => ({ backgroundColor: theme.palette.grey[200] }),
    rounded: { borderRadius: SKELETON_ROUNDED_RADIUS },
  },
};
